module.exports = __webpack_public_path__ + "img/comingsoon.c4a7d86f.png";